// 桌面小组件宿主。
//
// MVP（展示阶段）：位置固定在右上角，不支持拖动；widget 清单写死。
// spec 260509-system-monitor C-5：原 ``ServiceStatusWidget`` 已被
// ``SystemHealthWidget``（4 段健康摘要）替换；老组件文件已删除。
//
// 后续 phase 会加：
// - 从后端读每用户的位置偏移 + enabled 状态（widget_states 表）
// - 鼠标拖动并落 DB
// - 小组件管理 app 开关
//
// 见 docs/specs/260422-service-watchdog/前端设计.md §1 / §10。
import { useEffect } from 'react';

import { useWidgetConfigStore } from './hideErrorsFlag';
import { SystemHealthWidget } from './SystemHealthWidget';

export function WidgetHost() {
  // 启动时拉一次 widget 运行时开关(HIDE_HEALTH_ERRORS)。
  const load = useWidgetConfigStore((s) => s.load);
  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="widget-host" aria-label="桌面小组件">
      <SystemHealthWidget />
    </div>
  );
}
